import { Component, Input, OnInit } from '@angular/core';
import { register } from 'swiper/element/bundle';
import { IonicSlides } from '@ionic/angular';



@Component({
  selector: 'app-imagecarousel',
  templateUrl: './imagecarousel.component.html',
  styleUrls: ['./imagecarousel.component.scss'],
})
export class ImagecarouselComponent  implements OnInit {
  @Input() slides: string[];
  swiperModules = [IonicSlides];

  constructor() { }

  ngAfterViewInit() {
    register();
  }

  ngOnInit() {
  }

}
